/**
 * General Helpers.
 * 
 * Handles a lot of utility work.
 */

let debugNodeList = false

/**
 * Gets the value of a css variable on an element.
 */
export function getCssVar( variable, element = null ) {

    element = element instanceof Element ? element : document.body

    return window.getComputedStyle( element )
        .getPropertyValue( `--${variable}` )
}

/**
 * Gets all internal anchor links.
 */
export function getInternalLinks( includeAnchors = false ) {

    const protocols = ['http', 'https']
    const hostName =  top.location.host.toString()

    const selectors = [
        'a[href^="/"], a[href^="./"], a[href^=".."]' + ( includeAnchors ? ', a[href^="#"]' : '' )
    ];

    for ( const protocol of protocols ) {
        selectors.push( `a[href^="${protocol}://${hostName}"]` )
    }

    debugNodeList = true

    const nodeList = nodeListDiff(
        document.querySelectorAll( selectors.join( ', ' ) ),
        document.querySelectorAll( 'a[target="_blank"]' )
    )

    debugNodeList = false

    return nodeList
}

/**
 * Returns an array of elements from a nodeList only if they are not present in any others.
 */
export function nodeListDiff( nodeList, ...comparedNodeLists ) {

    const diff = [];

    for ( const node of nodeList ) {

        let inComparedNodeLists = false

        comparedListsLoop: for ( const comparedNodeList of comparedNodeLists ) {
            for ( const comparedNode of comparedNodeList ) {
                if ( node.isEqualNode( comparedNode ) ) {
                    inComparedNodeLists = true
                    break comparedListsLoop
                }
            }
        }

        if ( ! inComparedNodeLists ) {
            diff.push( node )
        }
    }

    return diff
}

/**
 * Determines if a value is numeric.
 */
export function isNumeric( value ) {

    switch ( typeof value ) {
        case 'number':
            return true
        case 'string':
            return !! ( +value === +value || value.match( /^[0-9,]*$/g ) )
        default:
            return false
    }
}

/**
 * Gets a number or numeric string's precision.
 */
export function getNumberPrecision( number ) {

    let p = 0

    if ( typeof number === 'string' ) {
        const decimals = number.split( '.' )[1] || ''
        p = decimals.length
    }

    else {

        if ( ! isFinite( number ) ) return 0

        let e = 1

        while ( Math.round( number * e ) / e !== number ) {
            e *= 10
            p++
        }
    }

    return p;
}

/**
 * A simple noop function.
 */
export const noop = () => {}

/**
 * Capitalizes the first letter of a string.
 */
export function ucFirst( string ) {
    return string.charAt( 0 ).toUpperCase() + string.slice( 1 );
}

/**
 * Converts a unix timestamp into a date string.
 */
export function timestampToDateString( timestamp, isLocalTime ) {

    const date = new Date( timestamp * 1000 )
    const options = isLocalTime ? {} : { timeZone: 'UTC' }

    return date.toLocaleDateString( navigator.locale, options )
}